//date picker

import './pickdatejs/picker.js'
import './pickdatejs/picker.date.js'
import './pickdatejs/ru_RU.js'

document.addEventListener('DOMContentLoaded', () => {
  $('.form-field__date').each(function () {
    const $dateInput = $(this)
    const pickerOptions = {
      today: '',
      clear: 'Закрыть',
      close: 'Выбрать',
      closeOnSelect: false,
      format: 'dd.mm.yy',
      onSet: function (context) {
        if (context && (context.select || context.clear)) {
          $dateInput[0].dispatchEvent(new CustomEvent('date-picker:change'))
        }
      },
      onOpen: function () {
        if ($dateInput.hasClass('pickerDate__input--target')) {
          $dateInput.pickadate().pickadate('pickerDate').close(true)
        }
      },
      onRender() {
        const picker = this.$root
        const iconArrowRight = '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-right"></use></svg>'
        picker.find('.pickerDate__nav--prev').html(iconArrowRight)

        picker.find('.pickerDate__nav--next').html(iconArrowRight)

        picker
          .find('.pickerDate__button--close')
          .html(
            '<span class="btn-text">Выбрать</span>' +
            '<span class="btn-icon">' +
            '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-top-right"></use></svg>' +
            '</span>'
          )
          .addClass('btn btn-bounce btn-bounce-primary')

        picker
          .find('.pickerDate__button--clear')
          .html('Закрыть <svg class="close-icon"><use xlink:href="/img/sprite.svg#icon-close"></use></svg>')
      },
    }

    if ($dateInput.attr('data-min-date') === 'today') {
      pickerOptions.min = true
    }

    $dateInput.pickadate(pickerOptions)
  })
})
